import { isLocal } from '@/utils/baseUrl';
import { doGet, doPost } from '@/utils/request';

let APIHost = '/lcsc-order';
if (isLocal) {
  APIHost = 'https://devorder.szlcsc.com';
}

const OrderApi = {
  selectWarehouse: `${APIHost}/select/customer/master/warehouse`,
};

export default OrderApi;

let domain = 'lcscOrderApiUrl';
if (isLocal) {
  domain = 'https://devorder-api.szlcsc.com';
}

// 星级询价
export function asyncBeforeEnquiryAdd(query) {
  return doGet(domain, `/async/before/enquiry/add/v2?way=1`, query);
}

// 校验无价格先行询价
export function asyncCheckNoPriceEnquiry(body) {
  return doPost(domain, `/async/check/noprice/enquiry`, body);
}

// 保存无价格先行询价
export function asyncNoPriceEnquirySave(body) {
  return doPost(domain, `/async/noprice/enquiry/save`, body);
}
